<template>
  <div class="justify-content-center text-left mt-5 dp02 p-5">
    <div class="col-lg-12">
      <b-button type="submit"
                class="myButton"
                @click="$router.go(-1)"
                style="float:left">
        {{ $t('common.Back') }}
      </b-button>

      <b-button type="submit"
                class="myButton"
                @click="$router.push({ name: 'admin.vouchers.productvouchers.edit', params: { id:id } });"
                style="float:right">
        {{ $t('common.Edit') }}
      </b-button>
      <b-button type="submit"
                class="myButton"
                @click="$refs.removeModal.show()"
                style="float:right">
        {{ $t('common.Remove') }}
      </b-button>
    </div>
    <div v-if="!ready"
         class="row mt-5">
      <b-spinner variant="primary"
                 type="grow"
                 label="Spinning" />
      <span>{{ $t('DataTable.Loading') }}...</span>
    </div>
    <div v-else
         class="row col-lg-12 mt-5">
      <div class="col-lg-12 row">
        <div class="col-lg-1 offset-lg-4">
          <label for="productTypeId">{{ $t('fields.productTypeId') }}</label>
        </div>
        <div class="col-lg-3">
          <ProductTypeInput
            v-model="productTypeId"
            ref="productType"
            :editable="false" />
        </div>
      </div>
      <div class="col-lg-12 row mt-3">
        <div class="col-lg-1 offset-lg-4">
          <label for="voucherType">{{ $t('fields.voucherType') }}</label>
        </div>
        <div class="col-lg-3">
          <VoucherTypeInput v-model="voucherType"
                            :editable="false" />
        </div>
      </div>
      <div class="col-lg-12 row mt-3"
           v-show="voucherType === 2">
        <div class="col-lg-1 offset-lg-4">
          <label for="forWho">{{ $t('fields.forWho') }}</label>
        </div>
        <div class="col-lg-3">
          <b-form-input
            :disabled="true"
            id="forWho"
            v-model="forWho"
            class="myInput" />
        </div>
      </div>
      <div class="col-lg-12 row mt-3"
           v-show="voucherType === 2">
        <div class="col-lg-1 offset-lg-4">
          <label for="fromWho">{{ $t('fields.fromWho') }}</label>
        </div>
        <div class="col-lg-3">
          <b-form-input
            :disabled="true"
            id="fromWho"
            v-model="fromWho"
            class="myInput" />
        </div>
      </div>
      <div class="col-lg-12 row mt-3">
        <div class="col-lg-1 offset-lg-4">
          <label for="code">{{ $t('fields.code') }}</label>
        </div>
        <div class="col-lg-3">
          <b-form-input
            :disabled="true"
            id="code"
            v-model="code"
            class="myInput" />
        </div>
      </div>
      <div class="col-lg-12 row mt-3">
        <div class="col-lg-1 offset-lg-4">
          <label for="validTo">{{ $t('fields.validTo') }}</label>
        </div>
        <div class="col-lg-3">
          <b-form-input
            :disabled="true"
            id="validTo"
            v-model="validToFormatted"
            class="myInput" />
        </div>
      </div>
      <div class="col-lg-12 row mt-3">
        <div class="col-lg-1 offset-lg-4">
          <label for="howMany">{{ $t('fields.redeemed') }}</label>
        </div>
        <div class="col-lg-3">
          {{ $t(`common.${redeemed}`) }}
        </div>
      </div>
    </div>
    <b-modal id="modal-center"
             ref="removeModal"
             centered
             :static="true">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 text-center">
          <h3>
            {{ $t('DataTable.RemoveTitle') }}
          </h3>
        </div>
      </template>
      <p class="my-4 text-center">
        {{ $t('DataTable.RemoveMessage', { 1: $t('entities.ProductVoucher.Singular') }) }}
      </p>
      <ValidationObserver
        ref="removeObserver"
        v-slot="{invalid}"
        tag="form">
        <div class="row">
          <div class="col-lg-4">
            <label for="removeNoteMessage">{{ $t('fields.note') }}:</label>
          </div>
          <div class="col-lg-6">
            <ValidationProvider
              name="removeNoteMessage"
              rules="required"
              v-slot="{errors, classes}">
              <b-form-input
                v-model="removeNoteMessage"
                :class="{...classes, myInput: true}" />
              <p class="myInputError mt-2">
                {{ errors[0] }}
              </p>
            </ValidationProvider>
          </div>
        </div>
      </ValidationObserver>
      <template #modal-footer="{ cancel, ok }">
        <b-button
          variant="secondary"
          @click="$refs.removeModal.hide();">
          {{ $t('common.Cancel') }}
        </b-button>
        <b-button
          variant="danger"
          @click="remove();">
          {{ $t('common.Delete') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import VoucherTypeInput from '@components/input/VoucherTypeInput';
import ProductTypeInput from '@components/input/ProductTypeInput';

export default {
  name: 'ProductVoucherViewDetail',
  components: {
    VoucherTypeInput, ProductTypeInput
  },
  data() {
    return {
      ready: false,
      removeNoteMessage: ''
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    validToFormatted() {
      return this.$moment(this.validTo).format('DD.MM.YYYY');
    },
    productTypeId: {
      get() {
        return this.$store.state.viewProductVoucher.productTypeId;
      },
      set() {
      }
    },
    ...mapState('viewProductVoucher', ['voucherType', 'fromWho', 'forWho', 'validTo', 'code', 'redeemed'])
  },
  mounted() {
    this.setId(this.id);
    this.fetchProductVoucher()
      .then(() => {
        this.ready = true;
      });
  },
  methods: {
    ...mapActions({ fetchProductVoucher: 'viewProductVoucher/fetchProductVoucher' }),
    ...mapMutations({ setId: 'viewProductVoucher/setProductVoucherId' }),
    async remove() {
      const isValid = await this.$refs.removeObserver.validate();
      if (!isValid) {
        return;
      }
      await this.axios.delete('/admin/vouchers/deleteproductvoucher', {
        params: {
          Id: this.id,
          Note: this.removeNoteMessage
        }
      }).then(async (res) => {
        if (res.status === 204) {
          this.$root.$bvToast.toast(this.$t('DataTable.RemoveSuccess', { 1: this.$t('entities.MoneyVoucher.Singular') }), {
            title: this.$t('DataTable.RemoveSuccessTitle'),
            variant: 'success',
            toaster: 'b-toaster-top-right'
          });
          this.removeNoteMessage = '';
          this.$refs.removeModal.hide();
          this.$router.push({ name: 'admin.vouchers.view' });
        }
      }).catch(() => {
        this.$refs.removeModal.hide();
        this.removeNoteMessage = '';
        this.$root.$bvToast.toast(this.$t('DataTable.RemoveFailure', { 1: this.$t('entities.MoneyVoucher.Singular') }), {
          title: this.$t('DataTable.RemoveFailureTitle'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
